import { useState } from "react";
import ReactPlayer from "react-player";
import { Modal, Button } from "react-bootstrap";
import styles from "./style.module.css";

export function PopupPlayer({ url, show: externalShow, onClose }) {
  const [show, setShow] = useState(externalShow || false);
  const [aspectRatio, setAspectRatio] = useState(null);
  const closePlayer = () => {
    setShow(false);
    if (onClose) onClose();
  };
  const handleReady = (player) => {
    const internalPlayer = player.getInternalPlayer();
    if (internalPlayer && internalPlayer.videoWidth && internalPlayer.videoHeight) {
      setAspectRatio(internalPlayer.videoWidth / internalPlayer.videoHeight);
    }
  };
  return (
    <Modal show={externalShow || show} onHide={closePlayer} className={styles.modal}>
      <Modal.Body className={styles.padding}>
        <ReactPlayer
          url={url}
          width={"100%"}
          height={"auto"}
          controls={true}
          muted={true}
          playing={true}
          onEnded={closePlayer}
          onReady={handleReady}
          playsinline={true}
        />
        <Button variant="secondary" className={styles.closeButton} onClick={closePlayer}>
          ×
        </Button>
      </Modal.Body>
    </Modal>
  );
}
